import type { RiskDescendantsResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetRiskDescendantIdsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskDescendantIdsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskDescendantIdsArgs = {
  riskId: string;
};

/**
 * Descendants of a risk two levels deep (RSP-6498), used by the
 * remove-from-enterprise-risk modal to warn about downstream impact before an
 * unlink. The tRPC row shape (`{ Id, childRisks: [{ Id }] }`) matches the V2
 * GraphQL `risk` selection, so no per-field mapping is needed.
 */
export const useGetRiskDescendantIds = createQueryHook<
  UseGetRiskDescendantIdsArgs,
  RiskDescendantsResponseRow[],
  GetRiskDescendantIdsQuery
>({
  trpcQueryOptions: (trpc, { riskId }) =>
    trpc.frontend.risk.descendantIds.queryOptions({ riskId }),
  mapTrpcDataToGraphQL: (data) => ({ risk: data }),
  graphqlDocument: GetRiskDescendantIdsDocument,
  graphqlVariables: ({ riskId }) => ({ Id: riskId }),
});
